import { Reveal } from "@/components/Reveal";

const STATS = [
  { id: "stat-capacity", num: "500+", unit: "MT", label: "Annual fabrication capacity" },
  { id: "stat-width", num: "1200", unit: "MM", label: "Maximum tray width" },
  { id: "stat-gauge", num: "2.5", unit: "MM", label: "Heaviest gauge we form" },
  { id: "stat-quote", num: "24", unit: "HR", label: "Quote turnaround" },
];

const MACHINES = ["CNC Punch Press", "Press Brake Forming", "MIG Welding Line", "Powder Coating Booth", "Debarring & Finishing", "In-house Tool Room"];

export const Capabilities = () => {
  return (
    <section id="capabilities" data-testid="capabilities-section" className="relative bg-royal py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0 texture-perf opacity-70 pointer-events-none" />

      <div className="relative max-w-[1440px] mx-auto px-5 md:px-10">
        <Reveal>
          <div className="mb-12 md:mb-16 text-center">
            <p className="font-mono text-[10px] md:text-xs tracking-[0.35em] uppercase text-white/60 mb-4">
              Manufacturing Capability
            </p>
            <h2 className="font-heading font-semibold uppercase text-3xl md:text-5xl tracking-wide text-white">
              On the Floor, Every Shift
            </h2>
          </div>
        </Reveal>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
          {STATS.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.07}>
              <div data-testid={s.id} className="bg-ink/40 border border-white/10 p-6 md:p-8 hover:bg-ink/60 transition-colors duration-300">
                <p className="font-heading font-semibold text-4xl md:text-5xl leading-none text-white">
                  {s.num}
                  <span className="text-lg md:text-xl align-top text-white/60 ml-1">{s.unit}</span>
                </p>
                <p className="mt-3 font-mono text-[10px] md:text-xs tracking-[0.25em] uppercase text-white/60">
                  {s.label}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-12 md:mt-16 max-w-3xl mx-auto">
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-10 border-t border-white/15" data-testid="machine-list">
              {MACHINES.map((m) => (
                <li key={m} className="py-3 border-b border-white/15 font-mono text-xs md:text-sm tracking-[0.15em] uppercase text-white/80 flex items-center gap-3">
                  <span className="w-1.5 h-1.5 bg-[#7FB3E8] rotate-45 inline-block" /> {m}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
